export default {
    setSummary (state, summary) {
        state.summary = summary
    },

}
